
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools/delete-pdf-pages",
      function () {
        return require("private-next-pages/signature/pdf-tools/delete-pdf-pages/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/pdf-tools/delete-pdf-pages"])
      });
    }
  